import { render, staticRenderFns } from "./TransactionFundraisingGoalTip.vue?vue&type=template&id=5e1e44aa&scoped=true&"
import script from "./TransactionFundraisingGoalTip.vue?vue&type=script&lang=ts&"
export * from "./TransactionFundraisingGoalTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e44aa",
  null
  
)

export default component.exports